export default class LoadMore {

    constructor() {
        this.settings = {
            $postsList : $('.posts-list')
        };

        this.bindUIActions();
    }

    bindUIActions = () => {
        if (this.settings.$postsList != null) {
            let postsList = this.settings.$postsList; // The container element that holds the list of posts
            let loadNr = $('#js-nr-posts-default').val(); // The number of posts to load
            let loadMoreBtn = $('.js-load-more'); // The button that triggers the loading of more posts
            let shownResultsElement = $('.js-shown-results'); // The element to display the number of shown posts

            const postTypeList = () => {
                $('.post-single').removeClass('hidden');
                postsList.find('.post-single').each((index, element) => {
                    if (index >= loadNr) {
                        $(element).addClass('hidden');
                    }
                });
            };

            const updateShownResults = () => {
                const shownPostsCount = postsList.find('.post-single:not(.hidden)').length;
                shownResultsElement.text(shownPostsCount);
            };

            postTypeList();
            updateShownResults(); // Update the shown results initially

            if (postsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            loadMoreBtn.on('click', (e) => {
                const $this = e.currentTarget;
                let morePosts = postsList.find('.hidden');
                let counter = 0;

                morePosts.each((index, element) => {
                    if (counter >= loadNr) {
                        return false;
                    }
                    counter++;
                    $(element).removeClass('hidden');
                });

                updateShownResults();

                if (postsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }

                // if the button is inside div.js-reviews-panel, set max-height to unset
                const reviewsPanel = $this.closest('.js-reviews-panel');
                if (reviewsPanel) {
                    $(reviewsPanel).css('max-height', 'unset');
                }
            });
        }
    };
};

new LoadMore();
